/**
 * Generated by orval 🍺
 * Do not edit manually.
 * clarityrcm.api
 * OpenAPI spec version: 1.0
 */
import type {
  ExceptionResponse,
  PracticeStripeConfig,
} from "../../../../../lib/api-types/schemas";

import { authenticatedClient } from "../../authenticatedClient";

export type getApiPracticesPracticeIdStripeConfigResponse200 = {
  data: PracticeStripeConfig;
  status: 200;
};

export type getApiPracticesPracticeIdStripeConfigResponse401 = {
  data: void;
  status: 401;
};

export type getApiPracticesPracticeIdStripeConfigResponse403 = {
  data: void;
  status: 403;
};

export type getApiPracticesPracticeIdStripeConfigResponse404 = {
  data: ExceptionResponse;
  status: 404;
};

export type getApiPracticesPracticeIdStripeConfigResponse409 = {
  data: ExceptionResponse;
  status: 409;
};

export type getApiPracticesPracticeIdStripeConfigResponse500 = {
  data: ExceptionResponse;
  status: 500;
};

export type getApiPracticesPracticeIdStripeConfigResponseSuccess =
  getApiPracticesPracticeIdStripeConfigResponse200 & {
    headers: Headers;
  };
export type getApiPracticesPracticeIdStripeConfigResponseError = (
  | getApiPracticesPracticeIdStripeConfigResponse401
  | getApiPracticesPracticeIdStripeConfigResponse403
  | getApiPracticesPracticeIdStripeConfigResponse404
  | getApiPracticesPracticeIdStripeConfigResponse409
  | getApiPracticesPracticeIdStripeConfigResponse500
) & {
  headers: Headers;
};

export const getGetApiPracticesPracticeIdStripeConfigUrl = (
  practiceId: string,
) => {
  return `/api/practices/${practiceId}/stripe-config`;
};

/**
 * **Actor types:** `clinic`, `internal`
 *
 * **Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims
 *
 * Read-only: creates nothing on the payment provider. Feed the response straight into loadStripe(publishableKey, { stripeAccount: connectedAccountId }).
 * @summary Retrieves the Stripe publishable key and connected account id for a practice.
 */
export const getApiPracticesPracticeIdStripeConfig = async (
  practiceId: string,
  options?: Parameters<typeof authenticatedClient>[1],
): Promise<getApiPracticesPracticeIdStripeConfigResponseSuccess> => {
  return authenticatedClient<getApiPracticesPracticeIdStripeConfigResponseSuccess>(
    getGetApiPracticesPracticeIdStripeConfigUrl(practiceId),
    {
      ...options,
      method: "GET",
    },
  );
};
